import type { SWRResponse } from "swr"
import { UserBasicInfo } from "types/apiTypes"
import { fetchApiData } from "hooks/useApiData"
import useRegionData from "hooks/useRegionData"

interface UserSWRResponse extends SWRResponse {
  data: UserBasicInfo | undefined
}

const useUser = () => {
  const {
    currentRegion: { languageCode }
  } = useRegionData()

  const {
    data: user,
    isLoading,
    isValidating,
    mutate
  } = fetchApiData(
    `accounts/user/?language_code=${languageCode}`
  ) as UserSWRResponse

  return {
    isLoggedIn: !!user && !user.isAnonymous && !user.isGuest,
    isAccountHolder: !!user && !user.isAnonymous,
    isGuest: !!user && user.isGuest,
    isAnonymous: !!user && user.isAnonymous,
    hasFullAccount: !!user && user.hasFullAccount,
    user,
    isValidating,
    isLoading,
    mutate
  }
}

export default useUser
